<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card style="background-color: #e1e9e9;">
                <v-card-text class="pa-0">
                  <v-container class="py-3">
                    <v-layout>

                      <v-flex xs12 md6>
                        <v-text-field label="Template Name"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md5>
                        <v-text-field 
                          label="Browse"
                          @click='onPickFile'
                          prepend-icon="attach_file"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md1>
                        <v-layout justify-space-around class="mb-2">
                          <span class="group pa-2">
                            <v-btn color="primary" small flat @click="selected_filter.splice(i,1)" :disabled="false">Add Template</v-btn>
                          </span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-card class="mt-2">
                <iframe
                  src="http://192.168.22.246:4001/"
                  width="100%"
                  height="600px"
                  frameborder="0"
                ></iframe>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
// import qb from "../../functions/query.builder";

export default {
  name: "doc_template",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      new_filter: {
        condition: "and",
        rules: []
      },
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      my_filter: {
        field: "",
        value: "",
      },
      selected_filter: [
        // {
        //   field:"hub",
        //   value:"MYPG",
        // },
        // {
        //   field:"department",
        //   value:"CSDS",
        // },
      ],
      table_setting: {
        loading: false,
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [],
        records: [],      
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 10,
          sortBy: "created",
          totalItems: 0
        }
      },
    //   dialog: {
    //     visible: false,
    //     title: "",
    //     appraisee: "",
    //     appraiser: "",
    //     iframe_url: "",
    //     height:"",
    //     rec_id:""
    //   },
      status_option: [],
      selected: {
        id: "",
        name: "",
        parent_company_id: "",
        g_status_id: "",
        desc: ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
    // "selected_filter":{
    //   handler:function(){
    //     console.log(this.selected_filter);
    //   }
    // }
  },
  async mounted() {
    // window.document.title="Talent Mgmt";
    this.username = auth.getUsername();

    var self = this;

    this.status_option = await common.App.getGeneralOptions(
      "General",
      "status",
      ["id", "value"]
    );

    function handleMessage(e) {

    }
    
    window.addEventListener("message", handleMessage, false);
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },

    async refreshData() {
     
    },    
    editRecord_onClick(item) {
      
    },
    addNewRecord_onClick() {
      this.$router.push({ path: "/doc_create" });
    },
    viewMenu() {
      this.showMenu = true;
    },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ name: action_name });
    // },
    save_onClick() {
      // let self = this;

      // this.$validator.validateAll().then(async result => {
      //   if (result) {
      //     let result = await common.wBackEndComm.PostData(
      //       "company/crud_company/",
      //       self.selected
      //     );

      //     if (result.data.Status == 1) {
      //       self.dialog.visible = false;
      //       self.refreshData();
      //       common.wMsgBox.Success(result.data.Description);
      //     } else {
      //       common.wMsgBox.Error(result.data.Description);
      //     }
      //   }
      // });
    }
  }
};
</script>

<style>

</style>
